import { Button } from "@/components/ui/button/button";
import { BwChevronLeftLine } from "@/components/ui/icons";

type BackButtonProps = {
  goBack: () => void;
  className?: string;
  disabled?: boolean;
};

export function BackButton({ goBack, className, disabled }: BackButtonProps) {
  return (
    <Button
      kind="soft"
      variant="neutral"
      onClick={goBack}
      size={"xs"}
      className={className}
      disabled={disabled}
    >
      <BwChevronLeftLine size={16} className={"stroke-dark-max"} />
      Back
    </Button>
  );
}
